/* eslint-disable no-unused-expressions */
import React, { useState } from "react";
import * as products_ from "../../CatalogProducts/operations";
import BootstrapTable from "react-bootstrap-table-next";
import Lightbox from "react-awesome-lightbox";
import PDFExport from "../../../helper/export-pdf";
import "react-awesome-lightbox/build/style.css";
import {
  Card,
  Container,
  Row,
  Col,
  Spinner,
} from "react-bootstrap";
import overlayFactory from "react-bootstrap-table2-overlay";
import moment from "moment";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";


export default function Products(props) {
  const _products = props.products.map((doc) => {
    return {
      ...doc,
      cost: "$" + Number(doc.cost).toFixed(2),
      srp: "$" + Number(doc.price).toFixed(2),
      "volume/metric": doc.volume + " " + doc.metric,
    };
  });

  const [isOpen, setOpen] = useState(false);
  const [content, setContent] = useState("");
  const columns = products_.columns_campaign.map((col) => {
    col.formatExtraData = {
      controller: (product) => {
        setOpen(true);
        setContent(
          product.image || process.env.REACT_APP_DEFAULT_PRODUCT_IMAGE
        );
      },
    };
    return col;
  });
  // const totalizer_cols = ["cost", "price", "available", "reserved"]
  // const money_cols = ["cost", "price"]
  const cols = columns.filter(
    (col) => col.text.toLocaleLowerCase() !== "actions"
  );

  return (
    <Card className="p-4 rounded-xl shadow-sm" style={{ minHeight: "600px" }}>
      {isOpen && (
        <Lightbox
          image={content}
          onClose={() => {
            setOpen(false);
            setContent("");
          }}
        />
      )}
      <Container fluid>
        <Row className="w-100 justify-content-between p-2">
          <div className="col-6 w-100 justify-content-end d-flex ">
            <h1>
              PRODUCTS
            </h1>
          </div>
          <PDFExport
            columns={["name", "volume/metric", "cost", "srp", "category"]}
            data={_products}
            name="products"
            sign={
              props.campaign.name +
              "\n" +
              moment(props.campaign.start_date).format("MMMM/DD/YY") +
              "-" +
              moment(props.campaign.end_date).format("MMMM/DD/YY")
            }
          >
            <button className="btn btn-warning font-weight-bolder mx-2">
              Export Data
            </button>
          </PDFExport>

        </Row>

        <Row>
          <Col>
            {!props.queryng ? (
              <BootstrapTable
                wrapperClasses="table-responsive"
                bordered={false}
                classes="table table-head-custom table-vertical-center"
                bootstrap4
                hover
                striped
                keyField="uid"
                loading={props.queryng}
                overlay={overlayFactory({ spinner: true })}
                noDataIndication={
                  <div className="mr-2 text-muted">No records found</div>
                }
                data={_products.map((doc, i) => ({
                  count: Number(i) + 1,
                  ...doc,
                }))}
                columns={cols}
              ></BootstrapTable>
            ) : (
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            )}
          </Col>
        </Row>
      </Container>
    </Card >
  );
}